import { CategoryForCourse } from '../models/category-for-course';
export class CategoryForCourseChecked extends CategoryForCourse {
  added?: boolean = false;
  removed?: boolean = false;
}
